export const useGetDetailView = () => {
  const detailView = {
    RevenueEstimate: 'BeginYearEstimateDetail',
    RevenueEstimateOtherByLaw: 'RevenueEstimateOtherByLaw',
    EstimateInvest: 'EstimateInvest',
    // Của lập dự toán
    // ExpenseRegular: 'EstimateRegularDetail',
    // ExpenseProgram: 'EstimateProjectDetail',
    // của lập và cân đối
    ExpenseRegularArrgrate: 'estimateArrgrateRegular',
    ExpenseProgramArrgrate: 'estimateArrgrateProject',
    EstimateBudgetArrgrate: 'estimateArrgrateBudget',
    // ExpenseProgram: 'BaseEstimateDetail',
    ExpenseEstimateOtherByLawArrgrate: 'EstimateArrgrateExpenseOther',
    EstimateArrgrateExpenseOther: 'EstimateArrgrateExpenseOther',
    EstimateBudgetArrgrate: 'EstimateArrgrateBudget',
    EstimateBudgetArrgrateSTC: 'EstimateArrgrateBudgetSTC',
    EstimateInvestArrgrate: 'EstimateArrgrateExpenseInvest',
    EstimateInvestArrgrateSTC: 'EstimateArrgrateExpenseInvest',
    RevenueExpenseFeesArrgrate: 'EstimateFeesTab', // thu chi phí lệ phí
    EstimateBudget: 'EstimateBudgetDetail',
    EstimateExpenseBusinessArrgrate: 'EstimateExpenseBusinessTab',
    RevenueOtherArrgrate: 'estimateArrgrateRevenueOther',
    RevenueOtherArrgrateSTC: 'estimateArrgrateRevenueOtherSTC',
  };
  const getDetailViewByCode = model => {
    return detailView[model.estimate_category_code];
  };
  return {
    getDetailViewByCode,
  };
};
